import * as React from 'react';
import { ArrowRightIcon } from '@heroicons/react/outline';
import { Icon } from '@vechaiui/react';
import { Link } from 'react-router-dom';

import MissionCard from './MissionCard';
import SingUpButtonGroupPage from './SignUpButtonGroupPage';
import StaticPageLayout from '#/layouts/StaticPageLayout';
import aboutUsBodyImg from '#/assets/static-page/about_us_body.jpg';
import aboutUsPageBg from '#/assets/static-page/about_us_main.png';
import { PublicRoute } from '#/constants/page-route';

const AboutUsPage = () => {
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <StaticPageLayout>
      <div>
        <div>
          <img src={aboutUsPageBg} className="object-cover w-full h-1/4" />
        </div>
        <div className="flex justify-center bg-white gap-x-16 p-14">
          <div className="basis-1/3">
            <img src={aboutUsBodyImg} />
          </div>
          <div className="flex flex-col gap-y-8 basis-1/2">
            <h2 className="text-blue-700">Your next MOVE in transportation</h2>
            <div className="text-justify text-gray-400">
              MOVE started as an idea that came to us when we were freight forwarders. As the
              middlemen between clients and transporters, we inevitably started to see the cracks in
              using the traditional methods to arrange the best means of transportation. From having
              to participate in bidding wars, miscommunications and constant competition, we realise
              things need to change. We must create a logistics solution to solve this.
            </div>
          </div>
        </div>
        <div className="py-20 pl-10 bg-blue-700 xl:pl-20">
          <div className="relative z-10 flex gap-x-10">
            <div className="flex flex-col flex-none gap-y-10 basis-2/6">
              <div className="space-y-4 text-white">
                <div className="text-sm">OUR MISSION</div>
                <div className="text-3xl">To standardise the transportation industry</div>
              </div>
              <div className="text-white">
                Our mission is to be the go-to transportation service that stems from:
              </div>
            </div>
            <MissionCard isBgBlue />
          </div>
        </div>
        <div className="py-20 bg-blue-50">
          <div className="flex items-center justify-center">
            <div className="flex flex-col">
              <h3>How can we help?</h3>
              <div className="text-lg text-center text-gray-400">Send us a message!</div>
              <div className="mt-10">
                <Link
                  className="flex items-center justify-between px-5 py-4 bg-blue-700 rounded-full w-72 hover:cursor-pointer"
                  to={PublicRoute.ContactUs}
                >
                  <span className="text-white">Contact Us</span>
                  <Icon as={ArrowRightIcon} className="w-5 text-white" label="selector" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <SingUpButtonGroupPage />
      </div>
    </StaticPageLayout>
  );
};

export default AboutUsPage;
